import React from 'react';
import PropTypes from 'prop-types';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import Button from '../../../shared/components/Button';
import { UserLabel } from '../../shared/components/UserLabel';
import { CompanyLabel } from '../../shared/components/CompanyLabel';
import { WorkLabel } from '../../shared/components/WorkLabel';
import { WorkerLabel } from '../../shared/components/WorkerLabel';
import { MachineLabel } from '../../shared/components/MachineLabel';
import { DocumentLabel } from '../../shared/components/DocumentLabel';
import './NotificationListItem.css';

export class NotificationListItem extends React.Component {

    render() {
        const {
            notification,
            hasPermissionToResolve,
        } = this.props;

        return (
            <div className="ps-notification-item">
                <div className="ps-notification-icon">
                    <i className="material-icons">{notification.icon()}</i>
                </div>
                <div className="ps-notification-labels">
                    <UserLabel user={notification.user()}/>
                    <CompanyLabel company={notification.company()}/>
                    <WorkLabel work={notification.work()}/>
                    <WorkerLabel worker={notification.worker()}/>
                    <MachineLabel machine={notification.machine()}/>
                    <DocumentLabel document={notification.document()}/>
                    {
                        notification.isSolved() ? (
                            <a className={hasPermissionToResolve ? '' : 'disabled'}
                               onClick={hasPermissionToResolve && this.undoResolve}>
                                <span className="label bg-orange">
                                    {I18nUtils.tr('TR_RESUELTA')}
                                    {hasPermissionToResolve &&
                                        <i className="material-icons img-close-label">close</i>}
                                </span>
                            </a>
                        ) : null
                    }
                    <span>{notification.listeriaDateDescription()}</span>
                </div>
                <div className="ps-notification-title">
                    {notification.title()}
                </div>
                <div className="ps-notification-message">
                    {notification.message() || '-'}
                </div>
                <div className="ps-notification-time">
                    <i className="material-icons">access_time</i>
                    <span>{notification.dateDescription()}</span>
                </div>
                <div className="ps-notification-button">
                    {
                        !hasPermissionToResolve || notification.isSolved() ? null : (
                            <Button
                                text={I18nUtils.tr('TR_RESOLVER')}
                                className="btn btn-primary waves-effect"
                                onClick={this.resolve}
                            />
                        )
                    }
                </div>
            </div>
        );

    }

    resolve = () => {
        const { notification, resolveNotification } = this.props;
        resolveNotification(notification, true);
    };

    undoResolve = () => {
        const { notification, resolveNotification } = this.props;
        resolveNotification(notification, false);
    };
}

NotificationListItem.propTypes = {
    notification: PropTypes.object.isRequired,
    resolveNotification: PropTypes.func.isRequired,
    hasPermissionToResolve: PropTypes.bool,
};

NotificationListItem.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/messages-notifications/notifications/list/NotificationListItem.jsx